import Ticker from '@advisor/models/Ticker';

export default class Asset {
  constructor(data = {}) {
    this.color = null;
    this.percentage = null;
    this.label = null;

    Object.assign(this, data);

    this.tickers = [];

    if (!data || !data.tickers) {
      return;
    }

    data.tickers.labels.forEach((label, index) => {
      this.tickers.push(
        new Ticker({
          code: data.tickers.labels[index],
          name: data.tickers.tooltips[index],
          percentage: data.tickers.datasets[0].data[index],
        })
      );
    });
  }

  getTickerPercentageTotal() {
    return this.tickers.reduce((acc, numData) => acc + Number(numData.percentage), 0).toFixed(2);
  }
}
